import { LOGGED_OUT } from 'actions/types';
import * as types from 'features/NordVpn/actions/types';
const initialState = {
    vpnStatus: 'not_registered',
    email: null,
};
const nordVpn = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_VPN_STATUS_SUCCESS:
            return {
                ...state,
                vpnStatus: action.payload.status,
                email: action.payload.email,
            };
        case types.ACTIVATE_VPN_SUCCESS:
            return {
                ...state,
                vpnStatus: action.payload.status,
            };
        case types.SET_VPN_STATUS:
            return { ...state, vpnStatus: action.payload.status };
        case LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export default nordVpn;
